import { makeApi } from "@zodios/core";
import { z } from "zod";

import { modulatorLastTemperaturePointDtoSchema } from "@/types/backoffice/dto/modulator/modulator-last-temperature-point-dto.ts";
import { modulatorPingDtoSchema } from "@/types/backoffice/dto/modulator/modulator-ping-dto.ts";

export const backofficeModulatorApi = makeApi([
  {
    method: "get",
    path: "/last-temperature-point",
    alias: "findModulatorsLastTemperaturePoint",
    parameters: [
      {
        name: "csModulators",
        type: "Query",
        schema: z.array(z.number()),
      },
    ],
    response: z.array(modulatorLastTemperaturePointDtoSchema),
  },
  {
    method: "get",
    path: "/:serial/ping",
    alias: "pingModulatorBySerial",
    response: modulatorPingDtoSchema,
  },
]);
